var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dx-popup',{staticClass:"popup",attrs:{"visible":_vm.showPopup,"drag-enabled":false,"close-on-outside-click":true,"show-title":true,"title":'Vertalingen wijzigen - ' + _vm.name,"onHidden":_vm.hide,"maxHeight":1000,"maxWidth":1000}},[_c('dx-toolbar-item',{attrs:{"widget":"dxButton","location":"after","options":{
        disabled: _vm.saving,
        text: _vm.$t('buttons.Save'),
        onClick: _vm.save,
        stylingMode: 'outlined',
        type: 'default',
        icon: _vm.saving ? 'fas fa-spin fa-spinner' : 'fas fa-save'
    }}}),_c('dx-scroll-view',[_c('DxForm',{attrs:{"form-data":_vm.translationsForm,"items":_vm.translationsGroup,"col-count":3}},[_c('DxColCountByScreen',{attrs:{"md":2}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }